export default ['teacherDiscountTypeB'];
